import { Injectable } from '@angular/core';

@Injectable()
export class PriceService {
    constructor(
    ) {

    }

    fixPriceFormat(price: string | number): string {
        if ((typeof price == 'string' && !price) || typeof price == 'undefined' || Object.is(price, null)) {
            return '';
        }

        if (typeof price != 'string') {
            price = price.toString();
        }
        return this.formatPrice(this.priceToFloat(price))
    }

    priceToFloat(price: string | number): number {
        if (price === null || typeof price === "undefined") {
            return 0;
        }

        // value formatted like '$123,456.00'
        var returnValue = price.toString().replace(/\$/g, '').replace(',', '');
        return parseFloat(returnValue);
    }

    formatPrice(value: number, precision: number = 2, prefix: string = "$"): string {
        return `${prefix}${value.toFixed(precision).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}`;
    }

    roundUp(value: number): string {
        var adjustment = 0.00499999999;
        return (value + adjustment).toFixed(2);
    }

    roundUpAsNumber(value: number): number {
        var adjustment = 0.00499999999;
        return this.priceToFloat((value + adjustment).toFixed(2));
    }
}



// WEBPACK FOOTER //
// ./src/services/helpers/price.service.ts